import DOMPurify from "dompurify";

export default function EventDescription({ value, className }) {
  const fragment = DOMPurify.sanitize(value || "", {
    ALLOWED_TAGS: ["a"],
    ALLOWED_ATTR: ["href", "title"],
    RETURN_DOM_FRAGMENT: true,
  });
  fragment.querySelectorAll("a").forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
  const container = document.createElement("div");
  container.appendChild(fragment);
  return <p className={className} style={{ whiteSpace: "pre-line" }}
    onClick={(event) => {
      if (event.target.closest("a")) event.stopPropagation();
    }}
    dangerouslySetInnerHTML={{ __html: container.innerHTML }} />;
}
